import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

import Select from '../../../components/ui/Select';

const MessageTemplateModal = ({ isOpen, onClose, onSend, recipientCount }) => {
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [customMessage, setCustomMessage] = useState('');
  const [includeAI, setIncludeAI] = useState(false);

  const templates = [
    { value: 'welcome', label: 'رسالة ترحيب', description: 'رسالة ترحيبية للعملاء الجدد' },
    { value: 'followup', label: 'متابعة', description: 'رسالة متابعة بعد الاجتماع' },
    { value: 'property_match', label: 'عقار مطابق', description: 'إشعار بعقار يطابق الاهتمامات' },
    { value: 'reminder', label: 'تذكير', description: 'تذكير بموعد أو مهمة' },
    { value: 'custom', label: 'رسالة مخصصة', description: 'كتابة رسالة جديدة' }
  ];

  const templateMessages = {
    welcome: `مرحباً بك في خدماتنا العقارية!\n\nنحن سعداء بانضمامك إلى عملائنا المميزين. فريقنا جاهز لمساعدتك في إيجاد العقار المثالي الذي يلبي احتياجاتك.\n\nلا تتردد في التواصل معنا في أي وقت.`,
    followup: `شكراً لوقتك معنا اليوم!\n\nنود متابعة مناقشتنا حول احتياجاتك العقارية. لدينا بعض الخيارات الجديدة التي قد تهمك.\n\nهل يمكننا تحديد موعد آخر للمناقشة؟`,
    property_match: `لدينا عقار جديد يطابق اهتماماتك!\n\nوجدنا عقاراً يتناسب مع متطلباتك من حيث الموقع والميزانية والمواصفات.\n\nهل ترغب في معرفة المزيد من التفاصيل؟`,
    reminder: `تذكير بموعدك القادم\n\nنود تذكيرك بموعدنا المحدد. نحن متحمسون للقائك ومناقشة خياراتك العقارية.\n\nنراك قريباً!`
  };

  const handleTemplateChange = (value) => {
    setSelectedTemplate(value);
    if (value !== 'custom' && templateMessages?.[value]) {
      setCustomMessage(templateMessages?.[value]);
    } else {
      setCustomMessage('');
    }
  };

  const handleSend = () => {
    if (!customMessage?.trim()) return;
    onSend({
      template: selectedTemplate,
      message: customMessage,
      useAI: includeAI,
      recipientCount
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-2xl max-h-[90vh] bg-card rounded-lg border border-border shadow-warm-xl flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-border flex-shrink-0">
          <div>
            <h3 className="text-xl font-heading font-semibold text-foreground">
              إرسال رسالة جماعية
            </h3>
            <p className="text-sm text-muted-foreground font-caption mt-1">
              سيتم إرسال الرسالة إلى {recipientCount} عميل
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors pointer-events-auto z-10"
            aria-label="إغلاق"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4 overflow-y-auto flex-1">
          <Select
            label="اختر قالب الرسالة"
            options={templates}
            value={selectedTemplate}
            onChange={handleTemplateChange}
            placeholder="اختر قالباً..."
            required
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              نص الرسالة
            </label>
            <textarea
              value={customMessage}
              onChange={(e) => setCustomMessage(e?.target?.value)}
              placeholder="اكتب رسالتك هنا..."
              rows={8}
              className="w-full px-4 py-3 text-sm bg-background border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring resize-none"
            />
            <p className="text-xs text-muted-foreground mt-2 font-caption">
              عدد الأحرف: {customMessage?.length}
            </p>
          </div>

          <div className="flex items-center gap-3 p-4 bg-accent/10 rounded-lg border border-accent/20">
            <input
              type="checkbox"
              id="includeAI"
              checked={includeAI}
              onChange={(e) => setIncludeAI(e?.target?.checked)}
              className="w-4 h-4 rounded border-input"
            />
            <label htmlFor="includeAI" className="flex-1">
              <div className="flex items-center gap-2">
                <Icon name="Sparkles" size={16} className="text-accent" />
                <span className="text-sm font-medium text-foreground">
                  تحسين الرسالة باستخدام ChatGPT
                </span>
              </div>
              <p className="text-xs text-muted-foreground mt-1 font-caption">
                سيتم تحسين صياغة الرسالة تلقائياً لتكون أكثر احترافية
              </p>
            </label>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
          >
            إلغاء
          </Button>
          <Button
            variant="default"
            iconName="Send"
            iconPosition="right"
            onClick={handleSend}
            disabled={!customMessage?.trim()}
          >
            إرسال الرسالة
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MessageTemplateModal;